import { render, staticRenderFns } from "./AddOnCarouselEl2.vue?vue&type=template&id=3a3e4c9e&scoped=true&"
import script from "./AddOnCarouselEl2.vue?vue&type=script&lang=ts&"
export * from "./AddOnCarouselEl2.vue?vue&type=script&lang=ts&"
import style0 from "./AddOnCarouselEl2.vue?vue&type=style&index=0&id=3a3e4c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e4c9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
